import { render, staticRenderFns } from "./GuiaRemisionConsulta.vue?vue&type=template&id=52819961&scoped=true&"
import script from "./GuiaRemisionConsulta.vue?vue&type=script&lang=js&"
export * from "./GuiaRemisionConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52819961",
  null
  
)

export default component.exports